const FONT_URL = 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap';
const FONT_FAMILY = '"Noto Sans JP", sans-serif';

export function initFont() {
  // Google Fonts の <link> を挿入
  if (!document.querySelector('link[data-font="noto-sans-jp"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONT_URL;
    link.dataset.font = 'noto-sans-jp';
    document.head.appendChild(link);
  }
  document.documentElement.style.setProperty('--font-family', FONT_FAMILY);
}
